'use strict';
module.exports = [
  '$scope',
  'channelsService',
  '$state',
  '$timeout',
  'toastService',
  function ($scope, channelsService, $state, $timeout, toastService) {
    $scope.channelForm;
    $scope.isCreate = !$state.params.id;

    $scope.hasPerms = function () {
      // return $stateParams.id ? $scope.jdroPerms.UPDATE : $scope.jdroPerms.CREATE;
      return true;
    };

    if ($state.params.id) {
      channelsService.getById({ id: $state.params.id }, function (response) {
        Object.assign($scope.channelForm, response);
      });
    } else {
      $timeout(function () {
        Object.assign($scope.channelForm, {
          clazz: 'com.dromedian.jdro.datex2.domain.Channel',
          fireBaseTopic: '',
          comments: [
            {
              locale: 'IT',
              comment: '',
            },
          ],
          active: true,
          visible: true,
        });
      });
    }

    $scope.isChannelCodeInvalid = function () {
      if (!$scope.channelForm.fireBaseTopic) {
        return false;
      }

      if (
        $scope.channelForm.fireBaseTopic &&
        !$scope.channelForm.fireBaseTopic.trim() &&
        document.getElementById('channelCode').classList.contains('ng-dirty')
      ) {
        return true;
      }

      return !$scope.channelForm.fireBaseTopic.match(/^[a-zA-Z0-9-_.~%]+$/);
    };

    $scope.submit = function () {
      if (!$scope.channelForm.comments[0].comment.trim()) {
        toastService.createErrorToast('Il campo Etichetta è obbligatorio');
        return;
      }

      if (!$scope.channelForm.fireBaseTopic) {
        toastService.createErrorToast('Il campo Codice è obbligatorio');
        return;
      }

      if (!$scope.channelForm.fireBaseTopic.match(/^[a-zA-Z0-9-_.~%]+$/)) {
        toastService.createErrorToast(
          'Il campo Codice contiene caratteri non validi'
        );
        return;
      }

      if ($state.params.id) {
        channelsService.update(
          $scope.channelForm,
          function () {
            $state.go('situation-record-channel-list');
          },
          function (error) {
            $scope.error = error.data;
          }
        );
      } else {
        channelsService.create(
          {
            clazz: $scope.channelForm.clazz,
            fireBaseTopic: $scope.channelForm.fireBaseTopic,
            comments: [
              {
                locale: 'IT',
                comment: $scope.channelForm.comments[0].comment.trim(),
              },
            ],
            active: $scope.channelForm.active,
            visible: $scope.channelForm.visible,
          },
          function () {
            toastService.createSuccessToast('Canale creato con successo');
            $state.go('situation-record-channel-list');
          },
          function (error) {
            toastService.createErrorToast(
              'Errore durante la creazione del canale'
            );
            $scope.error = error.data;
          }
        );
      }
    };

    $scope.cancel = function () {
      $state.go('situation-record-channel-list');
    };
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/channel/channelDetail/channelDetailCtrl.js
// module id = 250
// module chunks = 0